import React from 'react';
import { withStyles, Box } from '@material-ui/core';
import { Modal } from '@orijinworks/frontend-commons';
import EditorsSection from '../../create/CasePlanCreate/components/EditorsSection';
import { useEditorsPlanModalHook } from './useEditorsPlanModalHook';
import styles, { EditorsPlanModalStyles } from './editors-plan-modal.styles';

function EditorsPlanModal({ classes, open = false, planId, onClose, onSaved }) {
  const {
    modalRef,
    editors,
    canSave,
    handleEditorsChange,
    handleClose,
    handleSave,
  } = useEditorsPlanModalHook({ open, planId, onClose, onSaved });

  return (
    <Modal
      ref={modalRef}
      open={open}
      onClose={handleClose}
      onContinue={handleSave}
      heading="Editors"
      labelledBy="Editors"
      describedBy="Add or remove plan editors"
      cancelBtnText="Cancel"
      actionBtnText="Save"
      showCrossIcon
      modalType={{ type: 'normal', status: 'info', size: 'medium' }}
      continueButtonProps={{ disabled: !canSave }}
      styles={{ mainWrapperStyles: { width: 580, minWidth: 580, maxWidth: 780 } }}
      mainModalStyles={EditorsPlanModalStyles}
      showFooter
    >
      <Box className={classes.content}>
        <EditorsSection
          editors={editors}
          onEditorsChange={handleEditorsChange}
          showTitle={false}
          includeCreatorDefault={false}
        />
      </Box>
    </Modal>
  );
}

EditorsPlanModal.defaultProps = {
  open: false,
  planId: undefined,
  onClose: undefined,
  onSaved: undefined,
};

export default withStyles(styles)(EditorsPlanModal);
